export enum TrackingLabel {
  V1 = 'v1.2.0',
  YouTube = 'label_youtube',
  File = 'label_file',
}

export enum TrackingCategory {
  // social sharing buttons
  Social = 'category_social',
  // marketing pop ups
  Marketing = 'category_marketing',
  // login register and co
  Account = 'category_account',
  Transcription = 'category_transcription',
  Free = 'category_free_demo_song',
  User = 'category_user',
  Buy = 'category_buy',
  Checkout = 'category_checkout',
  ABTest = 'category_ab_test',
  Banner = 'category_discount_banner',
  Game = 'category_game',
}

export enum ABTestExperimentDimensions {
  AB_TEST_PRICING = 'pricing_experiment',
}

export enum ABTestBucket {
  CONTROL = 0,
  VARIANT = 1,
}

export enum TrackingAction {
  // social sharing
  CLICKED_STICKY_SHARE = 'action_clicked_sticky_share',

  // user actions
  USER_FEEDBACK_SENT = 'action_feedback_sent',
  USER_FORGOT_PASSWORD = 'action_forgot_password',
  USER_RESET_PASSWORD = 'action_reset_password',
  USER_RATE_RECOMMENDATION = 'action_rate_recommendation',

  // marketing
  STUDIO_BANNER_CLOSE = 'action_studio_banner_close',
  STUDIO_SUBSCRIBE_OPEN = 'action_studio_subscribe_open',
  STUDIO_SUBSCRIBE_ABORT = 'action_studio_subscribe_abort',
  STUDIO_SUBSCRIBE_SENT = 'action_studio_subscribe_sent',

  // transcription
  CREATE_FREE_TRANSCRIPTION = 'action_create_free_transcription',
  RATE_TRANSCRIPTION = 'action_rate_transcription',
  RATE_TRANSCRIPTION_FAILED = 'action_rate_transcription_failed',
  CLICK_ECARDS_CTA = 'action_click_ecards_cta',
  CLICK_XMAS_TOP_BANNER = 'action_click_xmas_topbanner',
  ECARD_CHANGE_AMOUNT = 'action_ecard_change_amount',
  ECARD_CHANGE_DESIGN = 'action_ecard_change_design',
  RETRANSCRIBE = 'action_retranscribe_transcription',
  EXPORT_CLICK = 'action_click_export',
  EXPORT_CLICK_LOCKED = 'action_click_export_locked',
  OPEN_SONGBOOK_TRANSCRIPTION = 'action_songbook_open_transcription',
  SONGBOOK_SEARCH_USED = 'action_songbook_search_used',

  SB_ITEM_CLICK_REFUND = 'action_songbook_item_click_refund',
  SB_ITEM_CLICK_EDIT = 'action_songbook_item_click_edit',
  SB_ITEM_CLICK_EXPORT = 'action_songbook_item_click_export',
  SB_ITEM_CLICK_DELETE = 'action_songbook_item_click_delete',
  SB_ITEM_CLICK_RETRANSCRIBE = 'action_songbook_item_click_retranscribe',
  SB_ITEM_CLICK_RETRY = 'action_songbook_item_click_retry',

  // account management
  ACCOUNT_REGISTER = 'action_account_register',
  ACCOUNT_REGISTER_GOOGLE = 'action_account_register_google',
  ACCOUNT_LOGIN = 'action_account_login',
  ACCOUNT_LOGIN_GOOGLE = 'action_account_login_google',
  CLICK_LOGIN = 'action_click_login',
  CLICK_REGISTER = 'action_click_register',

  // demo piece on landing page
  PLAY_DEMO_ORIGINAL = 'action_play_demo_original',
  PLAY_DEMO_SYNTHESIZED = 'action_play_demo_synthesized',

  // playback of transcription
  PLAY_ORIGINAL = 'action_play_original',
  PLAY_SYNTHESIZED = 'action_play_synthesized',
  PLAYBACK_END_ORIGINAL = 'action_playback_end_original',
  PLAYBACK_END_SYNTHESIZED = 'action_playback_end_synthesized',
  SELECT_SOURCE_ORIGINAL = 'action_select_source_original',
  SELECT_SOURCE_SYNTHESIZED = 'action_select_source_synthesized',

  // overlay checkout events
  CHECKOUT_PADDLE_PAST_EMAIL = 'action_checkout_paddle_pst_email',
  CHECKOUT_PADDLE_PAST_LOCATION = 'action_checkout_paddle_past_location',
  CHECKOUT_PADDLE_PAST_PAYMENT = 'action_checkout_paddle_past_payopt',
  CHECKOUT_PADDLE_PAST_PURCHASE = 'action_checkout_paddle_past_purchase',
  MARKETING_PADDLE_SUBSCRIBE = 'action_checkout_subscribe_marketing',

  // general purchase events
  CHECKOUT_PADDLE_MISSING_ORDER_ID = 'action_checkout_paddle_missing_order_id',
  CHECKOUT_PADDLE_MISSING_ORDER_ID_FAIL = 'action_checkout_paddle_missing_order_id_fail',

  // checkout for single purchase
  CHECKOUT_PADDLE_SINGLE_OPEN = 'action_checkout_paddle_single_open',
  CHECKOUT_PADDLE_SINGLE_ABORT = 'action_checkout_paddle_single_abort',
  CHECKOUT_PADDLE_SINGLE_SUCCESS = 'action_checkout_paddle_single_success',

  // checkout for package purchase
  CHECKOUT_PADDLE_PACKAGE_OPEN = 'action_checkout_paddle_package_open',
  CHECKOUT_PADDLE_PACKAGE_ABORT = 'action_checkout_paddle_package_abort',
  CHECKOUT_PADDLE_PACKAGE_SUCCESS = 'action_checkout_paddle_package_success',

  // checkout for subscriptions
  CHECKOUT_PADDLE_SUBSCRIPTION_OPEN = 'action_checkout_paddle_sub_open',
  CHECKOUT_PADDLE_SUBSCRIPTION_ABORT = 'action_checkout_paddle_sub_abort',
  CHECKOUT_PADDLE_SUBSCRIPTION_SUCCESS = 'action_checkout_paddle_sub_suc',

  // checkout for ecard purchase
  CHECKOUT_PADDLE_ECARD_OPEN = 'action_checkout_paddle_ecard_open',
  CHECKOUT_PADDLE_ECARD_ABORT = 'action_checkout_paddle_ecard_abort',
  CHECKOUT_PADDLE_ECARD_SUCCESS = 'action_checkout_paddle_ecard_success',

  // buy actions
  BUY_REFUND = 'action_refund',
  BUY_UNLOCK = 'action_unlock',
  SWITCH_PAYMENT_YEARLY = 'action_switch_payment_yearly',
  SWITCH_PAYMENT_MONTHLY = 'action_switch_payment_monthly',
  DISPLAY_PRICING = 'action_display_pricing',
  CLICK_PURCHASE_PRICING = 'action_click_purchase',

  // affiliate
  AFFILIATE_PURCHASE = 'action_affiliate_purchase',

  // upload
  UPLOAD_FILE = 'action_upload_file',

  // banner
  BANNER_CLOSE = 'action_banner_close',
  BANNER_CLICK = 'action_banner_click',

  // game
  GAME_START = 'action_game_start_click',
  GAME_REDIRECT = 'action_game_redirect_click',
  GAME_CLOSE = 'action_game_close',

  // share
  INVITE_FRIENDS = 'action_invite_friends_click',

  ACTION_CLICK_CHECKOUT = 'action_click_checkout',
  ACTION_CLOSE_CHECKOUT = 'action_close_checkout',

  CHECKOUT_A = 'action_checkout_a',
  CHECKOUT_B = 'action_checkout_b',
  CHECKOUT_SUCCESS_A = 'action_checkout_success_a',
  CHECKOUT_SUCCESS_B = 'action_checkout_success_b',
}

export type TrackingActionType = string | TrackingAction;

export class trackingService {
  static setUserId = (userId: string) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        0: 'config',
        1: 'GA_MEASUREMENT_ID',
        2: { user_id: userId },
      });
    } else if (window.gtag) {
      window.gtag('config', 'GA_MEASUREMENT_ID', {
        user_id: userId,
      });
    }
  };

  // https://developers.google.com/analytics/devguides/collection/gtagjs/pages
  static pageview = (url: string, trackingId: string) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'PageView',
        pagePath: url,
        trackingId,
        page_location: url,
      });
    } else if (window.gtag) {
      window.gtag('config', trackingId, {
        page_path: url,
      });
    }
  };

  static experimentEvent = (
    eventName: string,
    experimentId: ABTestExperimentDimensions,
    experimentValue: ABTestBucket
  ) => {
    const growthBookDimVal = `${experimentId}:${experimentValue}`;
    const obj = {
      event_category: TrackingCategory.ABTest,
      event_label: TrackingLabel.V1,
      [experimentId]: growthBookDimVal,
    };
    if (window.dataLayer) {
      window.dataLayer.push({
        event: eventName,
        ...obj,
      });
    } else if (window.gtag) {
      window.gtag('event', eventName, obj);
    }
  };

  // https://developers.google.com/analytics/devguides/collection/gtagjs/events
  static event = (
    category: TrackingCategory,
    action: TrackingActionType,
    label: TrackingLabel = TrackingLabel.V1
  ) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: action,
      });
    } else if (window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
      });
    }
    if (window.fbq) {
      if (action === TrackingAction.CREATE_FREE_TRANSCRIPTION) {
        window.fbq('track', 'ViewContent');
      }
      if (
        action === TrackingAction.CHECKOUT_PADDLE_PACKAGE_OPEN ||
        action === TrackingAction.CHECKOUT_PADDLE_SINGLE_OPEN ||
        action === TrackingAction.CHECKOUT_PADDLE_ECARD_OPEN
      ) {
        window.fbq('track', 'AddToCart');
      }
    }
  };

  // https://developers.google.com/analytics/devguides/collection/gtagjs/events
  static valuedEvent = (
    category: TrackingCategory,
    action: TrackingActionType,
    value: number | string = 0,
    label: TrackingLabel = TrackingLabel.V1
  ) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: action,
        value,
      });
    } else if (window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value,
      });
    }
  };

  static valueObjectEvent = <T extends Object>(
    category: TrackingCategory,
    action: TrackingActionType,
    value: Omit<T, 'event_category' | 'event_label' | 'type' | 'input' | 'location' | 'state'>,
    label: TrackingLabel = TrackingLabel.V1
  ) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: action,
        value,
      });
    } else if (window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        ...value,
      });
    }
  };

  static purchase = (
    transactionId: string,
    productId: string | number,
    productName: string,
    price: number,
    currency: string,
    additionalData:
      | {
          tax?: string | number;
          coupon?: string | number;
          affiliation?: string | number;
        }
      | undefined = undefined
  ) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
          transaction_id: transactionId,
          value: price,
          ...additionalData,
          shipping: null as null,
          currency,
          items: [
            {
              id: productId,
              name: productName,
              quantity: 1,
              price,
            },
          ],
        },
        transaction_id: transactionId,
        value: price,
        currency,
        items: [
          {
            id: productId,
            name: productName,
            quantity: 1,
            price,
          },
        ],
      });
    } else if (window.gtag) {
      window.gtag('event', 'purchase', {
        ecommerce: {
          transaction_id: transactionId,
          value: price,
          ...additionalData,
          shipping: null as null,
          currency,
          items: [
            {
              id: productId,
              name: productName,
              quantity: 1,
              price,
            },
          ],
        },
        transaction_id: transactionId,
        value: price,
        currency,
        items: [
          {
            id: productId,
            name: productName,
            quantity: 1,
            price,
          },
        ],
      });
    }

    if (window.fbq) {
      window.fbq('track', 'Purchase', {
        value: price,
        currency,
      });
    }
  };
}

export const TrackingTranscriptionParams = {
  location: {
    nav: 'nav',
    songbook: 'songbook',
    wp: 'wp',
    speed_dial: 'speed_dial',
  },
  input: {
    youtube: 'youtube',
    file: 'file',
    microphone: 'microphone',
    scan: 'scan',
  },
  action: {
    start: 'action_start_transcription',
    create: 'action_create_transcription',
    finish: 'action_finish_transcription',
    instruments: 'action_choose_instrument',
    lyrics: 'action_choose_language',
    close: 'action_wizard_close',
    stepChange: 'action_wizard_step_change',
  },
  type: {
    free: 'free',
    full: 'full',
  },
  state: {
    refund: 'refund',
    error: 'error',
    ok: 'ok',
  },
};
// returns the duration of the view in seconds, startTime has to be set first
export const getViewDuration = (startTime: number) => {
  return startTime ? (new Date().getTime() - startTime) / 1000 : undefined;
};
